import { Body1, makeStyles } from "@fluentui/react-components";
import { PanelDrawer } from "../../../../../components/Panel/PanelDrawer";
import { IEquipoModeloOperadorDTO } from "../../../../../Interfaces/auxiliar/IOperador";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";
import { UsePanelEliminarEquipoModeloOperador } from "./UsePanelEliminarEquipoModeloOperador";
import { Warning24Filled } from "@fluentui/react-icons";
import { PanelFooter } from "../../../../../components/Panel/PanelFooter";
import { useCallback } from "react";

const useStyles = makeStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignContent: "center",
      top: "100%",
      alignItems: "center",
    },
  
    warning: {
      color: " #eaa300",
      width: "60px",
      height: "60px",
    },
  });
export  interface IPanelEliminarEquipoModeloOperador extends IOpenPanel{
    item:IEquipoModeloOperadorDTO
}
export const PanelEliminarEquipoModeloOperador=(props:IPanelEliminarEquipoModeloOperador)=>{
    const styles = useStyles();
  const {request,setRequest,putEditarCatalogo,loading,reset,mensaje,status} = UsePanelEliminarEquipoModeloOperador(props)
  const onRenderFooter = useCallback(
          () => (
            <>
              <PanelFooter
                texto={"Eliminar"}
                texto2={"Salir"}
                onClick={putEditarCatalogo}
                onDismiss={() => {
                  reset()
                }}
              />
            </>
          ),
          [request]
        );
      return (
          <PanelDrawer
            isOpen={props.isOpen}
            onDismiss={reset}   
            textHeader={"Eliminar"}
            status={status}
            mensaje={mensaje}
            loading={loading}
            onRenderFooter={onRenderFooter}
          >
           <>
                      <div className={styles.container}>
                        <div>
                          <Warning24Filled className={styles.warning} />
                        </div>
                        <div>
                          <Body1>
                            ¿Desea 
                               Eliminar la relación {props.item.equipoModelo} con {props.item.nombrePersona}?
                          </Body1>
                        </div>
                      </div>
                    </>
         </PanelDrawer>
      )

}